/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-20 19:37:43
 * @FilePath: \baishu_react_ui\src\components\BsySwitchBtn\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import './index.css'

class BsySwitchBtn extends Component {


    constructor(props) {
        super(props);
        this.state = {
            power: props.power || false,
            customCls: props.customCls ? props.customCls : '',
        }
    }

    componentDidMount() {
        this.setState({ power: this.props.power })
    }

    switchClick = () => {
        const { power } = this.state
        this.setState({
            power: !power
        }, () => {
            this.props.switchChange && this.props.switchChange(this.state.power)
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.power !== prevProps.power) {
            this.setState({ power: this.props.power })
        }
    }

    render() {
        const { power, customCls } = this.state
        return (
            <div className={(power ? "BsySwitchBtn on" : "BsySwitchBtn off") + ' ' + customCls} onClick={this.switchClick}>
                {/* <span className="switchText">{React.language(power ? "on" : "off")}</span> */}
                <span className="powerSwitch" />
            </div>
        );
    }
}

export default BsySwitchBtn;